__turbopack_context__.v({
  "collapseContainer": "AOA3QG_collapseContainer",
  "collapsed": "AOA3QG_collapsed",
  "innerShadow": "AOA3QG_innerShadow",
  "moreButton": "AOA3QG_moreButton",
  "overflowing": "AOA3QG_overflowing",
  "title": "AOA3QG_title",
  "wrapper": "AOA3QG_wrapper",
});
